import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-start" }
const _hoisted_2 = { class: "d-flex flex-row mt-3" }
const _hoisted_3 = { class: "code-box code-box--with-border" }
const _hoisted_4 = {
  class: "text color--info",
  ref: "conversionLinuxMac"
}
const _hoisted_5 = { class: "d-flex flex-row mt-3" }
const _hoisted_6 = { class: "code-box code-box--with-border" }
const _hoisted_7 = {
  class: "text color--info",
  ref: "conversionWindows"
}
const _hoisted_8 = { class: "d-flex flex-row mt-3" }
const _hoisted_9 = { class: "code-box code-box--with-border" }
const _hoisted_10 = {
  class: "text color--info",
  ref: "digitalSignature"
}
const _hoisted_11 = { class: "d-flex flex-row mt-3" }
const _hoisted_12 = { class: "code-box code-box--with-border" }
const _hoisted_13 = {
  class: "text color--info",
  ref: "convertBase64Linux"
}
const _hoisted_14 = { class: "d-flex flex-row mt-3" }
const _hoisted_15 = { class: "code-box code-box--with-border" }
const _hoisted_16 = {
  class: "text color--info",
  ref: "convertBase64Mac"
}
const _hoisted_17 = { class: "d-flex flex-row mt-3" }
const _hoisted_18 = { class: "code-box code-box--with-border" }
const _hoisted_19 = {
  class: "text color--info",
  ref: "convertBase64Windows"
}
const _hoisted_20 = {
  class: "alert alert-dismissible alert-success mt-4",
  role: "alert"
}
const _hoisted_21 = { class: "alert__icon" }
const _hoisted_22 = { class: "d-flex flex-row mt-3" }
const _hoisted_23 = { class: "code-box code-box--with-border" }
const _hoisted_24 = {
  class: "text color--info",
  ref: "exportKey"
}
const _hoisted_25 = { class: "d-flex flex-row mt-3" }
const _hoisted_26 = { class: "code-box code-box--with-border" }
const _hoisted_27 = {
  class: "text color--info",
  ref: "runTheCheck"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[23] || (_cache[23] = _createElementVNode("div", { class: "text mt-4" }, "Após salvar o hash do termo digital, faça a conversão de hexa para binário:", -1)),
    _cache[24] || (_cache[24] = _createElementVNode("div", { class: "h6 mt-4" }, [
      _createElementVNode("strong", null, "Linux / MacOS"),
      _createTextVNode(":")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _cache[16] || (_cache[16] = [
          _createTextVNode("$ xxd -r -p "),
          _createElementVNode("span", { class: "red-background color--grayscale-dark" }, "digitalterm_hash.hex", -1),
          _createTextVNode(),
          _createElementVNode("span", { class: "red-background color--grayscale-dark" }, "digitalterm_hash.bin", -1)
        ]), 512)
      ]),
      _createVNode(_component_Icon, {
        class: "ms-3 m-auto",
        id: "copy-conversion-linux-mac",
        name: "copy",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.doCopy(this.$refs.conversionLinuxMac, 1))),
        onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.resetContent(1))),
        style: {"cursor":"pointer"}
      })
    ]),
    _cache[25] || (_cache[25] = _createElementVNode("div", { class: "h6 mt-4" }, [
      _createElementVNode("strong", null, "Windows"),
      _createTextVNode(":")
    ], -1)),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, "$ hex-to-bin.ps1", 512)
      ]),
      _createVNode(_component_Icon, {
        class: "ms-3 m-auto",
        id: "copy-conversion-windows",
        name: "copy",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.doCopy(this.$refs.conversionWindows, 2))),
        onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.resetContent(2))),
        style: {"cursor":"pointer"}
      })
    ]),
    _cache[26] || (_cache[26] = _createElementVNode("div", { class: "text mt-4" }, "Faça a assinatura digital:", -1)),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, _cache[17] || (_cache[17] = [
          _createTextVNode("$ openssl rsautl -sign -in "),
          _createElementVNode("span", { class: "red-background color--grayscale-dark" }, "digitalterm_hash.bin", -1),
          _createTextVNode(" -inkey "),
          _createElementVNode("span", { class: "red-background color--grayscale-dark" }, "cert1.key", -1),
          _createTextVNode(" -out "),
          _createElementVNode("span", { class: "red-background color--grayscale-dark" }, "signature.bin", -1)
        ]), 512)
      ]),
      _createVNode(_component_Icon, {
        class: "ms-3 m-auto",
        id: "copy-digital-signature",
        name: "copy",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.doCopy(this.$refs.digitalSignature, 3))),
        onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (_ctx.resetContent(3))),
        style: {"cursor":"pointer"}
      })
    ]),
    _cache[27] || (_cache[27] = _createStaticVNode("<div class=\"code-box mt-3\"><div class=\"text\">Enter pass phrase for cert1.key: <span class=\"red-background\">&lt;senha de proteção da chave privada&gt;</span></div></div><div class=\"text mt-4\">Converta para Base64:</div><div class=\"h6 mt-4\"><strong>Linux</strong>:</div>", 3)),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, _cache[18] || (_cache[18] = [
          _createTextVNode("$ base64 -w 64 -i "),
          _createElementVNode("span", { class: "red-background color--grayscale-dark" }, "signature.bin", -1)
        ]), 512)
      ]),
      _createVNode(_component_Icon, {
        class: "ms-3 m-auto",
        id: "copy-conversion-linux",
        name: "copy",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.doCopy(this.$refs.convertBase64Linux, 4))),
        onMouseleave: _cache[7] || (_cache[7] = ($event: any) => (_ctx.resetContent(4))),
        style: {"cursor":"pointer"}
      })
    ]),
    _cache[28] || (_cache[28] = _createElementVNode("div", { class: "h6 mt-4" }, [
      _createElementVNode("strong", null, "MacOS"),
      _createTextVNode(":")
    ], -1)),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, _cache[19] || (_cache[19] = [
          _createTextVNode("$ base64 -b 64 -i "),
          _createElementVNode("span", { class: "red-background color--grayscale-dark" }, "signature.bin", -1)
        ]), 512)
      ]),
      _createVNode(_component_Icon, {
        class: "ms-3 m-auto",
        id: "copy-conversion-mac",
        name: "copy",
        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.doCopy(this.$refs.convertBase64Mac, 5))),
        onMouseleave: _cache[9] || (_cache[9] = ($event: any) => (_ctx.resetContent(5))),
        style: {"cursor":"pointer"}
      })
    ]),
    _cache[29] || (_cache[29] = _createElementVNode("div", { class: "h6 mt-4" }, [
      _createElementVNode("strong", null, "Windows"),
      _createTextVNode(":")
    ], -1)),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, "$ base64.ps1", 512)
      ]),
      _createVNode(_component_Icon, {
        class: "ms-3 m-auto",
        id: "copy-conversion-windows-base64",
        name: "copy",
        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.doCopy(this.$refs.convertBase64Windows, 6))),
        onMouseleave: _cache[11] || (_cache[11] = ($event: any) => (_ctx.resetContent(6))),
        style: {"cursor":"pointer"}
      })
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_Icon, { name: "circle-check" })
      ]),
      _cache[20] || (_cache[20] = _createElementVNode("div", { class: "alert__content" }, [
        _createElementVNode("div", { class: "text" }, [
          _createTextVNode("O resultado dessa conversão deve ser informado no campo"),
          _createElementVNode("strong", null, "Assinatura do Termo Digital"),
          _createTextVNode(".")
        ])
      ], -1))
    ]),
    _cache[30] || (_cache[30] = _createElementVNode("div", { class: "h6 mt-4" }, [
      _createElementVNode("strong", null, "Se desejar, pode verificar a assinatura digital do termo"),
      _createTextVNode(":")
    ], -1)),
    _cache[31] || (_cache[31] = _createElementVNode("div", { class: "text mt-4" }, "Primeiro exporte a chave pública a partir da chave privada:", -1)),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, _cache[21] || (_cache[21] = [
          _createTextVNode("$ openssl rsa -in "),
          _createElementVNode("span", { class: "red-background color--grayscale-dark" }, "cert1.key", -1),
          _createTextVNode(" -pubout -out "),
          _createElementVNode("span", { class: "red-background color--grayscale-dark" }, "cert1.pub", -1)
        ]), 512)
      ]),
      _createVNode(_component_Icon, {
        class: "ms-3 m-auto",
        id: "copy-export-key",
        name: "copy",
        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.doCopy(this.$refs.exportKey, 7))),
        onMouseleave: _cache[13] || (_cache[13] = ($event: any) => (_ctx.resetContent(7))),
        style: {"cursor":"pointer"}
      })
    ]),
    _cache[32] || (_cache[32] = _createElementVNode("div", { class: "code-box mt-3" }, [
      _createElementVNode("div", { class: "text" }, [
        _createTextVNode("Enter pass phrase for cert1.key: "),
        _createElementVNode("span", { class: "red-background" }, "<senha de proteção da chave privada>"),
        _createTextVNode(" writing RSA key")
      ])
    ], -1)),
    _cache[33] || (_cache[33] = _createElementVNode("div", { class: "text mt-4" }, "E depois execute a verificação:", -1)),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, _cache[22] || (_cache[22] = [
          _createTextVNode("$ openssl pkeyutl -verify -in "),
          _createElementVNode("span", { class: "red-background color--grayscale-dark" }, "digitalterm_hash.bin", -1),
          _createTextVNode(" -pubin -inkey "),
          _createElementVNode("span", { class: "red-background color--grayscale-dark" }, "cert1.pub", -1),
          _createTextVNode(" -sigfile "),
          _createElementVNode("span", { class: "red-background color--grayscale-dark" }, "signature.bin", -1)
        ]), 512)
      ]),
      _createVNode(_component_Icon, {
        class: "ms-3 m-auto",
        id: "copy-run-the-check",
        name: "copy",
        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.doCopy(this.$refs.runTheCheck, 8))),
        onMouseleave: _cache[15] || (_cache[15] = ($event: any) => (_ctx.resetContent(8))),
        style: {"cursor":"pointer"}
      })
    ]),
    _cache[34] || (_cache[34] = _createElementVNode("div", { class: "code-box mt-3" }, [
      _createElementVNode("div", { class: "text" }, "Signature Verified Successfully")
    ], -1))
  ]))
}